import { eCDV3ItemTypes } from '../../enums/eCDV3ItemTypes';
import { titleFeeOptions } from './titleFeeOptions';
import { endorsementOptions } from './endorsementOptions';
import { ICDV3ViewItem } from '../interfaces/ICDViewItem';
import { prettyTaxType } from '../../enums/eTaxType';
import { prettyNonInterestPrepayments } from '../../enums/eNonInterestPrepayments';
import { prettyRecordingFee } from '../../enums/eRecordingFees';
import { isNil } from 'lodash';

export const generateDisplayLabel = (item: ICDV3ViewItem): string | null => {
  switch (item.type) {
    case eCDV3ItemTypes.aggregate_adjustment:
      return `Aggregate Adjustment`;
    case eCDV3ItemTypes.buyer_credit_from_seller:
      return `Buyer Credit From TSeller`;
    case eCDV3ItemTypes.buyer_credit_from_third_party:
      return `Buyer Credit From Third Party`;
    case eCDV3ItemTypes.buyer_deposit:
      return `Buyer Deposit`;
    case eCDV3ItemTypes.buyer_reimbursement_from_seller:
      return `Buyer Reimbursement to Seller`;
    case eCDV3ItemTypes.buyer_reimbursement_other_from_seller:
      return `Buyer Reimbursement from Seller - ${item.label}`;
    case eCDV3ItemTypes.buyer_reimbursement_other_to_seller:
      return `Buyer Reimbursement to Seller - ${item.label}`;
    case eCDV3ItemTypes.buyer_reimbursement_to_seller:
      return `Buyer Reimbursement to Seller`;
    case eCDV3ItemTypes.buyer_reimbursement_to_third_party:
      return `Buyer Reimbursement to Third Party`;
    case eCDV3ItemTypes.endorsement_other:
      return !isNil(item.label) ? item.label! : null;
    case eCDV3ItemTypes.endorsement: {
      const option = item.endorsement ? endorsementOptions.find(({ value }) => value === item.endorsement) : null;
      return option ? option.label : null;
    }
    case eCDV3ItemTypes.escrow_at_closing_other:
      return `Escrow At Closing ${item.label}`;
    case eCDV3ItemTypes.escrow_at_closing:
      return `Escrow At Closing`;
    case eCDV3ItemTypes.existing_loans_assumed:
      return `Existing Loans Assumed`;
    case eCDV3ItemTypes.hoa_fee:
      return `HOA Fee`;
    case eCDV3ItemTypes.interest_prepayment:
      return `interest Prepayment`;
    case eCDV3ItemTypes.lender_credit:
      return `Lender Credit`;
    case eCDV3ItemTypes.loan_amount:
      return `Loan Amount`;
    case eCDV3ItemTypes.non_interest_prepayment:
      return `Non Interest Prepayment - ${item.sub_type && prettyNonInterestPrepayments[item.sub_type]}`;
    case eCDV3ItemTypes.origination_fee_other:
      return `Origination Fee - ${item.label}`;
    case eCDV3ItemTypes.other_fee:
      return `Other Fee - ${item.label}`;
    case eCDV3ItemTypes.other_loan_cost:
      return `Loan cost - ${item.label}`;
    case eCDV3ItemTypes.payoff:
      return `Payoff`;
    case eCDV3ItemTypes.percentage_of_loan_amount:
      return `Percentage of Loan Amount`;
    case eCDV3ItemTypes.personal_property_sale:
      return `Personal Property Sale`;
    case eCDV3ItemTypes.prepayment_other:
      return `Prepayment ${item.label}`;
    case eCDV3ItemTypes.property_taxes:
      return `Property Taxes`;
    case eCDV3ItemTypes.recording_fee_other:
      return `Recording Fee - ${item.label}`;
    case eCDV3ItemTypes.recording_fee:
      return `Recording Fee - ${item.sub_type && prettyRecordingFee[item.sub_type]}`;
    case eCDV3ItemTypes.sale_price_of_property:
      return `Sale Price of Property`;
    case eCDV3ItemTypes.sales_tax:
      return `Sales Tax`;
    case eCDV3ItemTypes.appraisal_fee:
      return `Appraisal fee`;
    case eCDV3ItemTypes.seller_credit:
      return `Seller credit`;
    case eCDV3ItemTypes.seller_excess_deposit:
      return `Seller Excess Deposit`;
    case eCDV3ItemTypes.tax:
      return `Tax - ${item.sub_type && prettyTaxType[item.sub_type]}`;
    case eCDV3ItemTypes.tax_other:
      return `Tax - ${item.label}`;
    case eCDV3ItemTypes.title_fee_other:
      return !isNil(item.label) ? `Title - ${item.label}${item.payee ? ` to ${item.payee}` : ''}` : null;
    case eCDV3ItemTypes.title_fee: {
      const option = item.sub_type ? titleFeeOptions.find(({ value }) => value === item.sub_type) : null;
      if (option) return `${option.label}${item.payee ? ` to ${item.payee}` : ''}`;
      else throw new Error(`Label does not exist for ${item.type} ${item.sub_type}`);
    }
  }
};
